
import makerjs from "makerjs";
function C32(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W1 = Param[0].param,W = Param[1].param,H1 = Param[2].param,H = Param[3].param, R = Param[4].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       hh = H * 1 * myZoom,
       ww = W * 1 * myZoom,
       h1 = H1 * 1 * myZoom,
       w1 = W1 * 1 * myZoom,
       r = R * 1 * myZoom,
       w=w1,h=h1,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       /**
        * 
        * 已知拱高 弦长 求半径
        * r=(h/2)+(l*l)/(8*h)
        * 
        */
       Wh=(h1-hh)/2,Wl=ww,  //横向弧 拱高 弦长
       Hh=(w1-ww)/2,Hl=hh,  //竖向弧 拱高 弦长
       rw=(Wh/2)+(Wl*Wl)/(8*Wh),
       rh=(Hh/2)+(Hl*Hl)/(8*Hh),

       x0 = Hh, x1 = Hh, x2 = ww+Hh, x3 = ww+Hh, y0 = Wh, y1 = h1-Wh, y2 = h1-Wh, y3 = Wh,glassH = h, glassW = w;
console.log("w1,ww,h,hh,Wh,Wl,Hh,Hl,rw,rh=====",w1,ww,h,hh,Wh,Wl,Hh,Hl,rw,rh);
       if (hh !== 0) {
        var TxtH = H;
    }
    if (ww !== 0) {
        var TxtW = W;
    } if (h1 !== 0) {
      var TxtH1 = H1;
  }
  if (w1 !== 0) {
      var TxtW1 = W1;
  } if (r !== 0) {
    var TxtR = "R="+R;
}



   var drawAbnormalShapeC32 = {
       paths: {
        "LeftArcLine": new makerjs.paths.Arc([x0, y0], [x1, y1], rh, false, true),
        "TopArcLine": new makerjs.paths.Arc([x1,y1], [x2,y2], rw, false, true),
        "RightArcLine": new makerjs.paths.Arc([x2, y2], [x3, y3], rh, false, true),
        "BottomArcLine": new makerjs.paths.Arc([x3, y3], [x0, y0], rw, false, true),
       }
   };

   var fillet1 = makerjs.path.fillet(drawAbnormalShapeC32.paths.LeftArcLine, drawAbnormalShapeC32.paths.TopArcLine, r);
   var fillet2 = makerjs.path.fillet(drawAbnormalShapeC32.paths.TopArcLine, drawAbnormalShapeC32.paths.RightArcLine, r);
   var fillet3 = makerjs.path.fillet(drawAbnormalShapeC32.paths.RightArcLine, drawAbnormalShapeC32.paths.BottomArcLine, r);
   var fillet4 = makerjs.path.fillet(drawAbnormalShapeC32.paths.BottomArcLine, drawAbnormalShapeC32.paths.LeftArcLine, r);
   // var arc2 = makerjs.path.fillet(myButterflyGap4.paths.arc, myButterflyGap4.paths.line, 5);
 //add the fillet to the model
 drawAbnormalShapeC32.paths.fillet1 = fillet1;
 drawAbnormalShapeC32.paths.fillet2 = fillet2;
 drawAbnormalShapeC32.paths.fillet3 = fillet3;
 drawAbnormalShapeC32.paths.fillet4 = fillet4;

   var drawAbnormalShapeC32MarkR = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x3-3*markShift, y3+3*markShift], [x3, y3]),
        // "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
        // "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeC32MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([w1+ markShift, y3], [w1+ markShift, y3+hh]),
        "RightShortUpline": new makerjs.paths.Line([w1, y3+hh], [w1+ 2 * markShift, y3+hh]),
        "RightShortDnline": new makerjs.paths.Line([w1, y3], [w1+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeC32MarkH1 = {
       paths: {        
        "RightLine": new makerjs.paths.Line([w1+ 6*markShift, 0], [w1+ 6*markShift, 0+h1]),
        "RightShortUpline": new makerjs.paths.Line([w1, 0+h1], [w1+ 10 * markShift, 0+h1]),
        "RightShortDnline": new makerjs.paths.Line([w1, 0], [w1+ 10 * markShift, 0]),
       }
   };
   var drawAbnormalShapeC32MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, 0 - markShift], [x3, 0 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, 0], [x0, 0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, 0], [x3, 0 - 2 * markShift]),
       }
  //  };
  
   };
   var drawAbnormalShapeC32MarkW1 = {
       paths: {
        "BottomLine": new makerjs.paths.Line([0, 0 - 6*markShift], [w1, 0 - 6*markShift]),
        "BotmShortLfline": new makerjs.paths.Line([0, 0], [0, 0 - 10 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([w1, 0], [w1, 0 - 10 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeC32MarkW, TxtW, [x0, 0 - 2 * markShift], [x3, 0 - 2 * markShift]);//长度文字 
   makerjs.model.addCaption(drawAbnormalShapeC32MarkW1, TxtW1, [0, 0 - 8 * markShift], [w1, 0 - 8 * markShift]);//长度文字 
   makerjs.model.addCaption(drawAbnormalShapeC32MarkH, TxtH, [w1+ 2*markShift, y3], [w1+ 2*markShift, y3+hh]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeC32MarkH1, TxtH1, [w1+ 8*markShift, 0], [w1+ 8*markShift, 0+h1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeC32MarkR, TxtR, [x3-10*markShift, y3+5*markShift], [x3-6*markShift, y3+5*markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeC32: drawAbnormalShapeC32,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC32: drawAbnormalShapeC32,
        drawAbnormalShapeC32MarkR: drawAbnormalShapeC32MarkR,
        drawAbnormalShapeC32MarkH:drawAbnormalShapeC32MarkH,
        drawAbnormalShapeC32MarkW:drawAbnormalShapeC32MarkW,
        drawAbnormalShapeC32MarkH1:drawAbnormalShapeC32MarkH1,
        drawAbnormalShapeC32MarkW1:drawAbnormalShapeC32MarkW1
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C32;